"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = void 0;
var react_1 = require("react");
var useClickOutside = function (_a) {
    var ref = _a.ref, _b = _a.type, type = _b === void 0 ? "click" : _b, _c = _a.when, when = _c === void 0 ? true : _c, onClickOutside = _a.onClickOutside;
    var savedHandler = (0, react_1.useRef)(onClickOutside);
    var handleClick = (0, react_1.useCallback)(function (e) {
        if (ref && ref.current && !ref.current.contains(e.target)) {
            savedHandler.current(e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function () {
        savedHandler.current = onClickOutside;
    }, [onClickOutside]);
    (0, react_1.useEffect)(function () {
        if (when) {
            document.addEventListener(type, handleClick);
            return function () {
                document.removeEventListener(type, handleClick);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [when]);
};
exports.useClickOutside = useClickOutside;
//# sourceMappingURL=useClickOutside.js.map